export default __webpack_public_path__ + "static/media/YAS0930.34I-42407_-25404_0.e387ab17.jpg";